module.exports = __webpack_public_path__ + "data/0962607.countries.geo.json";